import { z } from "zod";

export const passwordRules = [
    {
        test: (p: string) => p.length >= 6,
        message: "Password must be at least 6 characters long",
    },
    {
        test: (p: string) => /[A-Z]/.test(p),
        message: "Password must contain at least one capital letter",
    },
    {
        test: (p: string) => /[!@#$%^&*()\-_=+{}[\]|\\;:'",.<>?]/.test(p),
        message: "Password must contain at least one special character",
    },
];

export const Password = z.string().superRefine((val, ctx) => {
    passwordRules.forEach((rule) => {
        if (!rule.test(val)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: rule.message,
            });
        }
    });
});
